import { EditOutlined } from '@ant-design/icons';
import { DateField, TextField } from '@refinedev/antd';
import { Button, DatePicker, Form } from 'antd';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import EditableModal, { useEditableModal } from '@/components/general/EditableModal';
import {
  EditableInfoItem,
  ShowInfoGrid,
  ShowInfoItem,
} from '@/components/general/ShowInfo/ShowInfo';
import { useUserContext } from '@/contexts/UserContext';
import { USER_WORK_AREA } from '@/model/General/UserWorkArea';
import { PACKAGE_STATES } from '@/model/Logistic/PackageStates';
import { Reception } from '@/model/Logistic/Reception/Reception';
import { useRepositoriesContext } from '@/repositories/RepositoriesContext';

interface ReceptionShowLogisticProps {
  record?: Reception;
  refetch?: () => void;
}

const ReceptionShowLogistic = (props: ReceptionShowLogisticProps) => {
  const { t } = useTranslation();
  const { record, refetch } = props;
  const { userWorkArea } = useUserContext();
  const { receptionRepository } = useRepositoriesContext();
  const { activeModal, openModal, closeModal } = useEditableModal<'entryDate'>();

  return (
    <ShowInfoGrid>
      <ShowInfoItem label={t('Observaciones')}>
        <TextField value={record?.comment ?? '-'} />
      </ShowInfoItem>
      <ShowInfoItem label={t('Fecha de recepción')}>
        {record?.date ? <DateField value={record?.date} /> : '-'}
      </ShowInfoItem>
      <EditableInfoItem
        label={t('Fecha de ingreso a operaciones')}
        action={
          userWorkArea == USER_WORK_AREA.LOGISTICS &&
          record?.status == PACKAGE_STATES.RECIBIDO && (
            <Button icon={<EditOutlined />} size="small" onClick={() => openModal('entryDate')} />
          )
        }>
        {/* Mostramos la fecha en formato local para la UI, aunque el backend la entregue en ISO. */}
        <TextField value={record?.entry_date ? dayjs(record.entry_date).format('L') : '-'} />
      </EditableInfoItem>

      <EditableModal
        activeModal={activeModal}
        closeModal={closeModal}
        modalConfigByKey={{
          entryDate: {
            title: t('Editar fecha de ingreso a operaciones'),
            form: {
              initialValues: { entryDate: record?.entry_date ? dayjs(record.entry_date) : null },
              onFinish: async values => {
                if (!record || values.entryDate === record.entry_date) {
                  return false;
                }

                await receptionRepository.updateReception(record.id, {
                  entry_date:
                    values.entryDate == undefined ? null : values.entryDate?.toISOString(),
                });
                refetch?.();
              },
              children: (
                <Form.Item name="entryDate">
                  <DatePicker
                    format={'L'}
                    placeholder={t('Seleccionar una fecha')}
                    style={{ width: '100%' }}
                  />
                </Form.Item>
              ),
            },
          },
        }}
      />
    </ShowInfoGrid>
  );
};

export default ReceptionShowLogistic;
